import styled from 'styled-components';
import type { TabsMod } from './index';

const TAB_MIN_HEIGHT_PX = 28;

export const TabsWrapper = styled.div`
    display: flex;
    min-height: ${TAB_MIN_HEIGHT_PX}px;
    overflow-x: auto;
    &::-webkit-scrollbar {
        height: 0;
        width: 0;
    }
`;

export const TabsScroll = styled.div<{ mod: TabsMod }>`
    display: flex;
    align-items: center;
    z-index: 2;
    padding: ${props => (props.mod === 'search' ? '0 16px' : '0')};
    overflow: auto;
    &::-webkit-scrollbar {
        display: none;
    }
`;

export const Tab = styled.div<{ isActive: boolean; disabled?: boolean; withEnterHotKey?: boolean }>`
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    margin-right: 16px;
    color: ${props =>
        props.isActive ? props.theme.root.colors.basicColors['90%'] : props.theme.root.colors.basicColors['50%']};
    padding: 0;

    &:last-child {
        margin-right: 0;
    }

    ${({ theme, isActive, withEnterHotKey }) =>
        withEnterHotKey &&
        !isActive &&
        `
            &:focus > div {
                color: ${theme.root.colors.basicColors['80%']};
            }
        `}

    ${props =>
        props.disabled &&
        `
        cursor: default;
        pointer-events: none;
        opacity: 0.3;
    `}
`;

export const BorderBottomHelper = styled.div<{ isActive: boolean }>`
    border: 1px solid ${props => (props.isActive ? props.theme.root.colors.primary.default : 'transparent')};
    border-radius: 2px;
    margin-top: 7px;
`;
